import classNames from 'clsx';
import React from 'react';
import type { CellProps } from 'react-table';

import type { TableColumn, Tournament } from '../../../types/MTT';
import TableCellBuyIn from '../TableCell/TableCellBuyIn';
import TableCellPlayers from '../TableCell/TableCellPlayers';
import {
  CELL_BUY_IN,
  CELL_GAME,
  CELL_NAME,
  CELL_PLAYERS,
  CELL_PRIZE_POOL,
  CELL_START_STATE
} from '../columnsConfig';

import styles from './Table.scss';

export const COLUMNS: TableColumn[] = [
  {
    ...CELL_NAME,
    width: undefined,
    cellStyles: classNames(CELL_NAME?.cellStyles, styles.cellName),
    cellExpand: false
  },
  {
    ...CELL_GAME,
    width: undefined,
    cellStyles: classNames(CELL_GAME?.cellStyles, styles.cellGame)
  },
  {
    ...CELL_START_STATE,
    width: undefined,
    cellStyles: classNames(CELL_START_STATE?.cellStyles, styles.cellStartState)
  },
  {
    ...CELL_BUY_IN,
    width: undefined,
    Cell: (props: CellProps<Tournament>) => <TableCellBuyIn {...props} showLabel />,
    cellStyles: classNames(CELL_BUY_IN?.cellStyles, styles.cellBuyIn)
  },
  {
    ...CELL_PRIZE_POOL,
    width: undefined,
    cellStyles: classNames(CELL_PRIZE_POOL?.cellStyles, styles.cellPrizePool)
  },
  {
    ...CELL_PLAYERS,
    width: undefined,
    Cell: (props: CellProps<Tournament>) => <TableCellPlayers {...props} showIcon />,
    cellStyles: classNames(CELL_PLAYERS?.cellStyles, styles.cellPlayers)
  }
];
